export default (url) => {
  if (url[0] === '/') {
    url = url.slice(1);
  }
  return url;
};
